import ShopifyFlowIcon from '@/icons/ShopifyFlowIcon';
import { Badge, BlockStack, Button, Card, InlineGrid, InlineStack, Link, Text } from '@shopify/polaris';
import { ExternalIcon } from '@shopify/polaris-icons';
import { StyledCustomWorkflows } from './styled';

const CustomWorkflows = () => {
  return (
    <StyledCustomWorkflows>
      <BlockStack gap="800">
        <BlockStack gap="200">
          <InlineStack gap="200">
            <Text variant="headingLg" as="h1">
              Custom workflows
            </Text>
            <Badge tone="success">Coming soon</Badge>
          </InlineStack>
          <Text variant="bodySm" as="p">
            Automate actions and send updates to customers based on shipment status changes.
          </Text>
        </BlockStack>

        <Card>
          <BlockStack gap="400">
            <InlineStack blockAlign="center" gap="400">
              <Text variant="headingMd" as="h2">
                Featured templates
              </Text>
              <div className="shopify-flow-badge">
                <ShopifyFlowIcon />
                Work with Shopify Flow
              </div>
            </InlineStack>

            <Text as="p" variant="bodyMd" tone="subdued">
              You need to use <Link url="https://apps.shopify.com/flow">Shopify Flow</Link> and ensure other connected apps are
              also configured for the workflow.
            </Text>

            <InlineGrid columns={{ xs: 1, md: 2 }} gap="400">
              <Card>
                <BlockStack gap="300">
                  <div>
                    <Badge>Reviews</Badge>
                  </div>
                  <Text variant="headingSm" as="h3">
                    Send Judge.me review request after 1 day shipment is delivered
                  </Text>
                  <Text as="p" variant="bodyMd" tone="subdued">
                    Trigger Judge.me to send a review request email.
                  </Text>
                  <div>
                    <Button disabled icon={ExternalIcon}>
                      Set up
                    </Button>
                  </div>
                </BlockStack>
              </Card>

              <Card>
                <BlockStack gap="300">
                  <div>
                    <Badge>Marketing</Badge>
                  </div>
                  <Text variant="headingSm" as="h3">
                    Push shipment status updates to Klaviyo
                  </Text>
                  <Text as="p" variant="bodyMd" tone="subdued">
                    Trigger Klaviyo campaigns based on shipment status.
                  </Text>
                  <div>
                    <Button disabled icon={ExternalIcon}>
                      Set up
                    </Button>
                  </div>
                </BlockStack>
              </Card>
            </InlineGrid>

            <Card>
              <BlockStack gap="300">
                <Text variant="headingSm" as="h2">
                  Build your own
                </Text>
                <Text as="p" variant="bodyMd" tone="subdued">
                  Fully customize workflows, triggers, and shipment status updates to any supported app.
                </Text>
                <InlineStack gap="200">
                  <Button disabled icon={ExternalIcon}>
                    Set up
                  </Button>
                  <Button disabled>Help doc</Button>
                </InlineStack>
              </BlockStack>
            </Card>
          </BlockStack>
        </Card>
      </BlockStack>
    </StyledCustomWorkflows>
  );
};

export default CustomWorkflows;
